import http from 'hasta-la-vista-middleware-api/http'
import {User} from 'hasta-la-vista-middleware-api/model'
import {AuthService, ErrorHandler} from 'hasta-la-vista-middleware-api/service'
import {Utils} from 'hasta-la-vista-ui-core'
import moment from 'moment'
import MetaData from  '../../../mixins/meta-data.js'

export default {
    name: 'user',
    props: {
        signUp: Boolean,
    },

    data() {
        return {
            msg: 'User',
            content: null,
            errors: [],
            loading: false,
            User: new User({SendNewsletter: true}),
            months: Utils.MonthMeta(),
            days: [],
            years: [],
            userLinkCards: false,
            userJoinSK: true,
            userSB1: false,
            userSB2: false,
            userNewsletter: false,
            isSKClub: false,
            userSKClubGroup: '',
            cardSKClub: false,
            cardVitality: false,
            cardEdgars: false,
            cardSKClubNumber: "",
            cardVitalityNumber: "",
            cardEdgarsNumber: "",
            idNumber: "",
            signInType: this.$route.params.signInType || false,
            tooltip: false,
            disabled: 0,
            activationCode: this.$route.params.activationCode,
            codeActivated: false,
            signUpChange: this.signUp || false,
            signUpLoading: false,
            generalErrors: [],
            passwordRegex: new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})"),
            subsClub: null,
            countryCode: null,
            mobilePhone: null,
            countryCodes: [],
            countryCodeIndex: [{id: "South Africa (+27)", value: "+27"},{id: "Zambia (+260)", value: "+260"},{id: "Zimbabwe (+263)", value: "+263"},{id: "Namibia (+264)", value: "+264"},],
            FbLogin: ()=> {
            }
        }
    },
    methods: {
        signup() {
            this.signUpLoading = true;

            if (this.disabled)
                return;
            //disable the form
            this.disabled = 1;

            this.User.MemberLevelId = 1;

            this.User.save().then((response)=> {
                this.loading = false;
                window.location.href = ('/user/profile');
                window.scroll({top: 0, left: 0})
            }, (error)=> {
                this.signUpLoading = false;
                this.disabled = 0
            });
        },

        login() {
            this.loading = true;
            this.disabled = 1;
            AuthService.signIn(this.User.Email, this.User.Password).then((user) => {
                this.loading = false;
                
                localStorage.removeItem("firstLogin")
                localStorage.setItem("firstLogin", "true")

                AuthService.firstLogin = true
                
                if (this.$route.query.redirect)
                    this.$router.push({path:(this.$route.query.redirect)})
                else
                    this.$router.push({path: '/user/profile'})
                
                // window.location.href = ('/user/profile');
            }, (error)=> {
                this.loading = false;
            })
        },

        loginState() {
            this.loading = true;
            this.disabled = 1;
            // this.loading = true;
            checkLoginState();
        },

        activateCode() {
            this.loading = true;
            if (this.activationCode.length === 15) {
                //alert("activate");

                Promise.resolve(http.post('/check-activation', {
                    activationCode: this.activationCode,
                })).then(res => {
                    if (res.status) {
                        this.codeActivated = true;
                        this.$toaster.show('You have successfully confirmed your account. Log in to continue to your profile page.', {
                            top: true,
                            timeout: 5000,
                            primary: true
                        });
                        this.loading = false;
                    }
                });
            }
        },

        signOut() {
            Promise.resolve(AuthService.signOut()).then((result) => {
                    this.$router.push("/");
                },
                (error) => {
                    Promise.reject(error)
                })
        },

        fbSignIn(r){
            AuthService.facebookSignUp(r).then((result) => {
                this.loading = false;
                this.$router.push({path: '/user/profile'})
            })
        },

        getSubsData() {
            let subsClubRaw = window.localStorage.getItem('subsClub');

            let subsClub = null
            if(subsClubRaw && subsClubRaw != undefined) {
                subsClub = JSON.parse(subsClubRaw)
            }

            this.subsClub = subsClub
            return subsClub
        },
    },

    created() {
        // window.scroll({top: 0, left: 0}) 
        // window.scrollTo(0,0)
        if (!this.signInType) {
            this.signInType = 'signup';
        }

        // console.log(this.months)

        for(let d = 1; d <= 31; d++) {
            this.days.push(d)
        }

        let year = new Date().getFullYear()

        this.countryCodes.push("South Africa (+27)");
        this.countryCodes.push("Zambia (+260)");
        this.countryCodes.push("Zimbabwe (+263)");
        this.countryCodes.push("Namibia (+264)");



        // console.log(this.countryCodes)

        // console.log(year)

        // console.log(this.days)

        for(let y = year; y >= (year - 110); y--) {
            this.years.push(y)
        }

        // console.log(this.years)

        this.getSubsData();

        window.fbAsyncInit = function () {

            FB.init({
                appId: '933552150135286',
                cookie: true,
                xfbml: true,
                version: 'v2.8'
            });

            FB.AppEvents.logPageView();

            var fbResponse = this.fbSignIn;

            window.checkLoginState = function () {
                FB.login(function (resp) {
                    let access_token = resp.authResponse.accessToken;
                    let fbUrl = '/me?fields=email,name,first_name,last_name,birthday';
                    FB.api(fbUrl, function (response) {
                        if (response.error === undefined) {
                            response.tkn = access_token;
                            fbResponse(response);
                        }
                    });
                }, {scope: 'email,public_profile,user_birthday'})

            }.bind(this);


        }.bind(this);

        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    },

    computed: {
        currentYear() {
            return moment().format('YYYY')
        },
        activateRedirect() {
            if (this.$route.query && this.$route.query.redirect) return this.$route.query.redirect.includes('/user/activate/')
            else return false                
        },
        emailChangeRedirect() {
            if (this.$route.query && this.$route.query.redirect) return this.$route.query.redirect.includes('/user/confirm-email-change/')
            else return false                
        }
    },

    mounted(){
        //After resetting your password
        if (this.signInType === 'reset') {
            this.$toaster.show('Your password has been reset. Please log in below', {
                top: true,
                timeout: 5000,
                primary: true
            });
        }

        //After welcome redirect after signup
        if (this.signInType === 'welcome') {
            this.$toaster.show('Sign up to SK successful. Please check your email for the activation link', {
                top: true,
                timeout: null,
                primary: true
            });
        }


        if (this.signInType === "sign-out") {
            this.signOut();
        }

        //Check the user's activation code
        if (this.activationCode !== undefined) {
            if (this.activationCode.length === 15) {
                this.codeActivated = false;
                this.activateCode();
                //this.$toaster.show('Activating', { top: true, timeout: 5000, primary: true });
            }
        }
        window.scrollTo(0, 0)
        window.scroll({top: 0, left: 0})
    },

    updated(){
        //on update re enable the ability ro submit the form
        // this.signInType = this.$route.params.signInType || 'signup',
        //     console.log('here',this.signInType);
        // this.disabled = 0;
    },

    watch: {
        signUpChange: {

            handler: Utils.debounce(function () {
                this.$emit('changed', [this.signUpChange])
            }, 300),
            deep: true
        },

        countryCode() {
            let value = null

            for(let i = 0; i < this.countryCodeIndex.length; i++) {
                if(this.countryCodeIndex[i].id == this.countryCode) {
                    value = this.countryCodeIndex[i].value
                }
            }

            if(this.mobilePhone != undefined && this.mobilePhone != null) {
                this.User.MobilePhone = value + this.mobilePhone
            }

            // console.log(this.User)
        },

        mobilePhone() {
            let value = null

            if(this.countryCode != undefined && this.countryCode != null) {
                for(let i = 0; i < this.countryCodeIndex.length; i++) {
                    if(this.countryCodeIndex[i].id == this.countryCode) {
                        value = this.countryCodeIndex[i].value
                    }
                }
                this.User.MobilePhone = value + this.mobilePhone
            }

            // console.log(this.User)
        },

        '$route' (to, from, el) {
            if (from.name === to.name) window.location.reload()
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/user/user.js